import React, { useEffect } from "react";
import { ADSENSE_CLIENT } from "../adsConfig";

// Renders a Google AdSense unit when a client + slot are configured; otherwise
// shows a placeholder so the real estate is visible pre-approval. The AdSense
// loader script is injected by the server template (gated on ADSENSE_CLIENT).
export default function AdSlot({
  slot = "",
  label = "Advertisement",
  size = "300 × 250",
  caption = "Keeping the lights on",
}) {
  const live = Boolean(ADSENSE_CLIENT && slot);

  useEffect(() => {
    if (!live) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, [live]);

  return (
    <div className="ad-wrap">
      <span className="ad-caption">{caption}</span>
      {live ? (
        <ins
          className="adsbygoogle ad-slot-live"
          style={{ display: "block", width: 300, height: 250 }}
          data-ad-client={ADSENSE_CLIENT}
          data-ad-slot={slot}
        />
      ) : (
        <div
          className="ad-slot"
          role="complementary"
          aria-label="Advertisement placeholder"
        >
          <span className="ad-slot-label">{label}</span>
          <span className="ad-slot-size">{size}</span>
        </div>
      )}
    </div>
  );
}
